import { useId } from 'react';
import { useAccount } from '../contexts/AccountContext';

/**
 * Picks ONE account out of the current scope for pages whose data is
 * inherently per account (billing, trends). Rendered only in portfolio mode;
 * in single-account mode the active account is used directly.
 */
export function AccountSelect({
  value,
  onChange,
  label,
}: {
  value: string | null;
  onChange: (customerId: string) => void;
  label: string;
}) {
  const { accounts } = useAccount();
  const id = useId();
  return (
    <div className="flex flex-wrap items-center gap-2">
      <label htmlFor={id} className="text-sm text-text-muted">
        {label}
      </label>
      <select
        id={id}
        value={value ?? ''}
        onChange={(event) => onChange(event.target.value)}
        className="min-h-11 max-w-full rounded-md border border-border bg-surface px-2 text-sm font-medium text-text focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary sm:min-h-9 sm:max-w-sm"
      >
        {accounts.map((account) => (
          <option key={account.customer_id} value={account.customer_id}>
            {account.name}
          </option>
        ))}
      </select>
    </div>
  );
}
